import { render, staticRenderFns } from "./SiteSetting.vue?vue&type=template&id=022d3eb6&scoped=true"
import script from "./SiteSetting.vue?vue&type=script&lang=js"
export * from "./SiteSetting.vue?vue&type=script&lang=js"
import style0 from "./SiteSetting.vue?vue&type=style&index=0&id=022d3eb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022d3eb6",
  null
  
)

export default component.exports